// extracted by mini-css-extract-plugin
module.exports = {"container":"AgentListItem--styles-module_container-XKL8_","profilePhotoSmall":"AgentListItem--styles-module_profilePhotoSmall-5yQPp"};